module.exports = __webpack_public_path__ + "img/c_01.a450515e.png";